<!-- 图书柜-我要买书-商品详情 -->
<template>
  <div class="BookcaseGsDetail" v-if="detail.pid">
    <div class="detailBox">
      <swiper class="imgList" :options="swiperOption" ref="mySwiper">
        <swiper-slide class="imgLi" v-for="(item) in detail.imgList" :key="item.pid"><img class="img" :src="item" alt=""></swiper-slide>
        <div class="swiper-pagination"  slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
      <div class="detail">
        <p class="bookName">{{detail.name}}</p>
        <div class="row">
          <p class="barCode">商品条码：{{detail.sn}}</p>
          <p class="price">￥{{detail.price}}</p>
        </div>
        <p class="intro">简介：{{detail.intro}}</p>
      </div>
    </div>
    <p class="bbtn bbtn-p" @click="goOpenBox">开箱</p>
  </div>
</template>

<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import { messageError, messageSuccess, showLoading, hideLoading } from '../../../../static/js/utils/utility'
  import { ECMallApi } from '../../../../static/Bookcase/js/api'
  import * as config from '../../../../static/js/config.js'
  
  let vm

  export default {
    name:'BookcaseGsDetail',
    components: {
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    data() {
      return {
        swiperOption: {
          // direction: 'vertical', // 垂直切换选项
          loop: true, // 循环模式选项
          pagination: {
            el: '.swiper-pagination',
          },
          // 如果需要前进后退按钮
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },

        detail: {},
      }
    },
    created() {
      vm = this
      vm.getProductById()
    },
    mounted () {
      console.log('this', this.$route)
    },
    methods: {
      // 获取商品详情
      async getProductById() {
        let data = { 
          pid: vm.$store.state.ECMall_activeGoods.pid
        }

        showLoading('获取商品详情中')
        let res = await ECMallApi.getProductById(data)
        hideLoading()
          if (res.meta.code === 200) {
            vm.detail = res.data 
          } else {
            messageError(res.meta.message)
          }
      },
      // 开箱门(买书开箱取物为3)
      async goOpenBox () {
        let item = vm.detail
        let data = {
          type: 3,
          cabinet_id: config.deviceId,
          pid: item.pid
        }

        // console.log(data)
        showLoading('正在开箱')
        let res = await ECMallApi.openBox(data)
        hideLoading()
        if (res.meta.code === 200) {
          // console.log(res)
          vm.$router.push('/Bookcase/BScanCode')
        } else {
          // messageError(res.meta.message)
          messageError('开箱失败,请点击右下方按钮联系客服')
        }
      },
    },
    watch: {
    },
  }
</script>

<style lang="less">
.Bookcase{
  .BookcaseGsDetail {
    width: 100%;
    padding: 0.5rem 0.61rem 0;
    .detailBox {
      width: 100%;
      height: 9.44rem;
      margin-bottom: 0.76rem;
      background-color: #ffffff;
      box-shadow: 0 0.02rem 0.24rem rgba(0, 0, 0, 0.21);
      .imgList {
        width: 100%;
        height: 5.25rem;
        padding-top: 0.35rem;
        .imgLi {
          display: flex;
          justify-content: center;
          .img {
            width: 3.3rem;
            height: 4.4rem;
          }

        }
        .swiper-pagination {
          bottom: 0;
          .swiper-pagination-bullet {
            width: 0.15rem;
            height: 0.15rem;
            margin: 0 0.23rem;
            background: #bfbfbf;
            &.swiper-pagination-bullet-active {
              background: #707070;
            }
          }
        }
        .swiper-button-prev,
        .swiper-button-next {
          width: 0.35rem;
          height: 0.7rem;
          top: 2.66rem;
          margin-top: 0;
          background: url(/static/Bookcase/images/icon_swiper.png) center no-repeat;
          background-size: 100% 100%;
        }
        .swiper-button-prev {
          left: 0.85rem;
        }
        .swiper-button-next {
          transform: rotate(180deg);
          right: 0.85rem;
        }
      }
      .detail {
        .bookName {
          font-size: 0.4rem;
          line-height: 1;
          font-weight: bold;
          text-align: center;
          margin: 0.35rem 0;
        }
        .row {
          width: 100%;
          padding: 0 0.42rem;
          line-height: 0.45rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .barCode {
            color: #777777;
            font-size: 0.28rem;
          }
          .price {
            font-size: 0.45rem;
            color: #d72f2f;
            font-weight: bold;
          }
        }
        .intro {
          width: 100%;
          padding: 0.2rem 0.42rem 0;
          font-size: 0.24rem;
          line-height: 0.34rem;
          color: #777777;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 6;
          overflow: hidden;
        }
      }
    }
    .bbtn {
      font-size: 0.4rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bookcase/Buy/GoodsDetail.vue